import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { PrimaryColor } from "../../shared/styles/colors";
import { Card, CardContent, Typography } from "@material-ui/core";
import Pathnames from "../../model/enum/Pathnames";
import Tags from "./tag/Tags";
import TagGroups from "./tagGroup/TagGroups";
import useStyles from "../styles/cardStyles";

const Overviewm = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  let pathname = location.pathname;

  const mapValueFromUrl = (): number => {
    if (pathname.split("/")[4] === 'tag-groups') return 1;

    return 0;
  };

  const [value, setValue] = useState(mapValueFromUrl()); // Active tab

  const DisplayTab = () => {
    switch (value) {
      case 0:
        return <Tags />;
      case 1:
        return <TagGroups />;
      default:
        return <></>;
    }
  };

  const handleChange = (_event: any, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Card raised className={classes.card}>
        <div className={classes.headerContainer}>
          <Typography className={classes.title}>Overview</Typography>
        </div>
        <CardContent>
          <Box sx={{ width: "50%", borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              centered
              variant="fullWidth"
              textColor="inherit"
              indicatorColor="primary"
              TabIndicatorProps={{
                sx: { height: 2, bgcolor: PrimaryColor }, // Customize the underline
              }}
            >
              <Tab
                label="Tags"
                sx={{
                  opacity: value === 0 ? 1 : 0.5,
                  textTransform: "capitalize",
                }}
                onClick={() => navigate(Pathnames.TAGS_LIST)}
              />
              <Tab
                label="Groups"
                sx={{
                  opacity: value === 1 ? 1 : 0.5,
                  textTransform: "capitalize",
                }}
                onClick={() => navigate(Pathnames.TAG_GROUPS_LIST)}
              />
            </Tabs>
          </Box>
          <DisplayTab />
        </CardContent>
      </Card>
    </>
  );
};

export default Overviewm;
